import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const systemFieldList = createSlice({
  name: "systemFieldList",
  initialState,
  reducers: {
    addSystemFieldList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { addSystemFieldList } = systemFieldList.actions;
export default systemFieldList.reducer;
